import { AngularEditorConfig } from '@kolkov/angular-editor';

export const emailEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '44vh',
    maxHeight: '44vh',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: false,
    toolbarHiddenButtons: [
        ['strikeThrough'],
        ['subscript'],
        ['superscript'],
        ['indent'],
        ['outdent'],
        ['insertImage'],
        ['insertVideo'],
        ['insertHorizontalRule'],
        ['removeFormat'],
        ['toggleEditorMode']
    ]
} as AngularEditorConfig;
